<div *ngIf="badge" class="position-relative">
  <i [ngClass]="icon ? icon : ''"></i>
  <div *ngIf="badge.default" class="badge default" [ngStyle]="{'background-color': 'var(--secondary)'}" >{{badge.default}}</div>
  <div *ngIf="badge.activities" class="badge activities" [ngStyle]="{'background-color': 'var(--primary)'}" >{{badge.activities}}</div>
</div>

<i *ngIf="!badge" [ngClass]="icon ? icon : ''"></i>
